import { Injectable } from '@angular/core';
import { AdminProviderService } from '@shared/services/http/http-provider.service';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AdminService {

  constructor(private httpProvider: AdminProviderService) { }

  public createUser(body: any) {
    return this.httpProvider.sendPostRequest('/user', body, new HttpHeaders, new HttpParams);
  }

  public updateUser(body: any, id: string){
    return this.httpProvider.sendPutRequest(`/user/${id}`, body, new HttpHeaders, new HttpParams);
  }

  public viewUser(id: string) {
    return this.httpProvider.sendGetRequest(`/user/${id}`, new HttpHeaders, new HttpParams);
  }
  public getUser(email: string) {
    return this.httpProvider.sendGetRequest(`/user/${email}`, new HttpHeaders, new HttpParams);
  }

  public searchUser(queryString: string) {
    return this.httpProvider.sendPostRequest('/user/search',
                                             { 'queryString': queryString }, new HttpHeaders, new HttpParams);
  }

  public getTeamleadUser(body) {
    return this.httpProvider.sendPostRequest('/user/teamlead', body, new HttpHeaders, new HttpParams);
  }

  public getBPMUser() {
    return this.httpProvider.sendGetRequest('/user/bpm', new HttpHeaders, new HttpParams)
  }

  public getOfficeFrontliners(office) {
    return this.httpProvider.sendPostRequest('/user/frontliners', {officeID: office}, new HttpHeaders, new HttpParams)
  }

 /* public createUserProfile(pname) {
    return this.httpProvider.sendPostRequest('/user/profiles/create', { profile_name: pname, status: 0 }, new HttpHeaders, new HttpParams)
  }*/

  //---ADDED FOR PHASE 2---
  public getAccessRights() //for user profiles
  {
    return this.httpProvider.sendGetRequest('/user/permissions/list', new HttpHeaders, new HttpParams)
  }

  public getUserProfilesList()
  {
    return this.httpProvider.sendGetRequest('/user/profiles/list', new HttpHeaders, new HttpParams)
  }

  public getUserProfileInfoByID(id : string)
  {
    return this.httpProvider.sendGetRequest(`/user/profiles/${id}`, new HttpHeaders, new HttpParams)
  }

  public searchUserProfile(queryString: string) {
    return this.httpProvider.sendPostRequest(`/user/profiles/search`,
                                             {'queryString': queryString },
                                              new HttpHeaders, new HttpParams);
  }

  public setUserProfileStatus(body: any, id: string) {
    return this.httpProvider.sendPutRequest(`/user/profiles/status/update/${id}`, body, new HttpHeaders, new HttpParams);
  }
  public createUserProfile(queryString: any)
  {
    return this.httpProvider.sendPostRequest('/user/profiles/create', queryString, new HttpHeaders, new HttpParams)
  }

  public updateUserProfile(id: string, queryString: any)
  {
    return this.httpProvider.sendPutRequest(`/user/profiles/update/${id}`, queryString, new HttpHeaders, new HttpParams)
  }

//FOR CONFIG SETTINGS:
  public viewRecommendationLogic()
  {
    return this.httpProvider.sendGetRequest('/config/view-recommendation', new HttpHeaders, new HttpParams)
  }

  public updateRecommendationLogic(queryString: any)
  {
    return this.httpProvider.sendPutRequest('/config/update', queryString, new HttpHeaders, new HttpParams)
  }

  public viewSuspensionDelisting()
  {
    return this.httpProvider.sendGetRequest('/config/view-suspension-delisting',  new HttpHeaders, new HttpParams)
  }

  public updateSuspensionDelisting(queryString: any)
  {
    return this.httpProvider.sendPutRequest('/config/update-suspension-delisting', queryString, new HttpHeaders, new HttpParams)
  }

  public createStatusTagging(queryString: any)
  {
    return this.httpProvider.sendPostRequest('/violation/create', queryString , new HttpHeaders, new HttpParams);
  }

  public updateStatusTagging(id: string, queryString : any)
  {
    return this.httpProvider.sendPutRequest(`/violation/edit/${id}`, queryString, new HttpHeaders, new HttpParams);
  }

  public viewStatusTaggingById(id: string)
  {
    return this.httpProvider.sendGetRequest(`/status-tagging/view/${id}`, new HttpHeaders, new HttpParams);  
  }

  public viewStatusTagging()
  {
    return this.httpProvider.sendGetRequest('/status-tagging/view', new HttpHeaders, new HttpParams);  
  }

  public deleteStatusTagging(id: string)
  {
    return this.httpProvider.sendDeleteRequest(`/status-tagging/delete/${id}`, new HttpHeaders, new HttpParams);
  }

  public viewCBMRatingList(page: number, keyword: string, sortBy: string, orderBy: string, forExport: boolean = false) {
    const skipCount =  (page - 1) * 10;
    return this.httpProvider.sendGetRequest(`/management/cbm-tech-rating/view?skipCount=${skipCount}`
                                              + `&sort=${sortBy}`
                                              + `&order=${orderBy}`
                                              + `&keyword=${keyword}`
                                              + `${forExport ? '&limit=all' : ''}`,
                                              new HttpHeaders,
                                              new HttpParams);
  }

  public getEnergizedSRs(refNo: string) {
    const skipCount = 0;
    return this.httpProvider.sendGetRequest(`/management/cbm-tech-rating/view?skipCount=${skipCount}`
        + `&sort=`
        + `&order=`
        + `&keyword=${refNo}`,
        new HttpHeaders,
        new HttpParams);
  }

  public submitCBMRating(refNo:any, rating: string)
  {
    let body = {'tech_rating': rating}
    return this.httpProvider.sendPostRequest(`/management/cbm-tech-rating/${refNo}`, body, new HttpHeaders, new HttpParams);
  }

  public addViolationToCBM(cbmId: string, body: any)
  {
    return this.httpProvider.sendPostRequest(`/violation/tag-contractor/${cbmId}`, body, new HttpHeaders, new HttpParams);
  }

  public getViolationFromCBM(cbmId:string)
  {
    return this.httpProvider.sendGetRequest(`/violation/contractor/${cbmId}`, new HttpHeaders, new HttpParams);
  }

  public getTransactionalHistory()
  {
    return this.httpProvider.sendGetRequest(`/management/sr-closed-cancelled/view?skipCount`, new HttpHeaders, new HttpParams);
  }

  public getAdminReport(reportType: any, body: any) {
    if (body.dateRangeFrom === '' && body.dateRangeTo === '') {
      return this.httpProvider.sendGetRequest(`/report?report_type=${reportType}`, new HttpHeaders, new HttpParams);
     }
    return this.httpProvider.sendGetRequest(
      `/report?report_type=${reportType}&start_date=${body.dateRangeFrom}&end_date=${body.dateRangeTo}`,
      new HttpHeaders,
      new HttpParams
      );
  }

  public monitorViolationStatus()
  {
    let body = {
      'body': ""
    }
    return this.httpProvider.sendPostRequest(`/violation/check/call`, body,new HttpHeaders, new HttpParams);
  }

  public addViolationDateReported(violation_id : string, body: any)
  {
    return this.httpProvider.sendPostRequest(`/violation/update-contractor-violation/${violation_id}`, body, new HttpHeaders, new HttpParams);
  }

}
